export const uploadAcceptedExtensions = new Set([
  "pdf",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xls",
  "xlsx",
  "xlsm",
  "xlsb",
  "csv",
  "shp",
  "shx",
  "dbf",
  "prj",
  "cpg",
  "sbn",
  "sbx",
  "qix",
  "dwg",
  "dxf",
  "dwf",
  "dwfx",
]);
export const uploadAcceptedMimePrefixes = ["image/", "video/", "audio/"];
export const uploadMaxFileSize = 50 * 1024 * 1024;
export const uploadMaxFilesPerBatch = 10;
export const uploadAcceptAttribute = [
  ".pdf",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".xls",
  ".xlsx",
  ".xlsm",
  ".xlsb",
  ".csv",
  ".shp",
  ".shx",
  ".dbf",
  ".prj",
  ".cpg",
  ".sbn",
  ".sbx",
  ".qix",
  ".dwg",
  ".dxf",
  ".dwf",
  ".dwfx",
  "image/*",
  "video/*",
  "audio/*",
].join(",");
export const supportedFileGroups = [
  { label: "documents", value: "pdf, doc, docx" },
  { label: "presentations", value: "ppt, pptx" },
  { label: "spreadsheets", value: "xls, xlsx, xlsm, xlsb, csv" },
  { label: "images", value: "all image types" },
  { label: "videos", value: "all video types" },
  { label: "audio", value: "all audio types" },
  { label: "gis", value: "shp, shx, dbf, prj, cpg, sbn, sbx, qix" },
  { label: "cad", value: "dwg, dxf, dwf, dwfx" },
] as const;
